import { Toaster } from 'react-hot-toast';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { QueryProvider } from './providers/QueryProvider';
import Router from './Router';
import { periodicServiceWorkerUpdates } from './utils/periodicServiceWorkerUpdates';

export function App() {
  useRegisterSW({
    immediate: true,
    onRegisteredSW: periodicServiceWorkerUpdates,
  });

  return (
    <QueryProvider>
      <Router />

      <Toaster />
    </QueryProvider>
  );
}
